var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5094 11.7868H11.4094V11.8868V18.3019C11.4094 19.1901 10.6995 19.9 9.81132 19.9C8.92315 19.9 8.21321 19.1901 8.21321 18.3019V11.8868V11.7868H8.11321H1.69811C0.809945 11.7868 0.1 11.0768 0.1 10.1887C0.1 9.30051 0.809945 8.59057 1.69811 8.59057H8.11321H8.21321V8.49057V1.69811C8.21321 0.809945 8.92315 0.1 9.81132 0.1C10.6995 0.1 11.4094 0.809945 11.4094 1.69811V8.49057V8.59057H11.5094H18.3019C19.1901 8.59057 19.9 9.30051 19.9 10.1887C19.9 11.0768 19.1901 11.7868 18.3019 11.7868H11.5094Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.c0a0d93a676dbef7c9269d249dab2ba9.svg";
export { ForwardRef as ReactComponent };